module.exports = __webpack_public_path__ + "img/pricing-icon-black.c6695719.png";